import { Component, inject, input } from '@angular/core';
import { DOMHandlerService } from '../../../services/domhandler.service';
import SplitType from 'split-type';
import gsap from 'gsap';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Image } from '../../apartment/header/header.component';
import { LanguageService } from '../../../services/language.service';

@Component({
    selector: 'app-section-card',
    imports: [NgClass, RouterLink],
    templateUrl: './section-card.component.html',
})
export class SectionCardComponent {
    data = input.required<SectionCard>();
    isLeft = input.required<boolean>();
    link = input.required<string>();
    domHandler = inject(DOMHandlerService);
    languageService = inject(LanguageService);

    ngAfterViewInit() {
        let typeSplit = new SplitType('[animate]', {
            types: 'chars',
            tagName: 'span',
        });
        const chars = typeSplit.chars;

        gsap.fromTo(
            chars,
            {
                y: 100,
                opacity: 0,
            },
            {
                y: 0,
                opacity: 1,
                stagger: 0.05,
                duration: 0.5,
                ease: 'power4.out',
            },
        );

        chars?.forEach((char, index) => {
            char.addEventListener('mouseenter', () => {
                gsap.to(chars[index - 1], {
                    y: -3,
                    duration: 0.2,
                    ease: 'power4.out',
                });
                gsap.to(char, {
                    y: -10,
                    duration: 0.2,
                    ease: 'power4.out',
                });
                gsap.to(chars[index + 1], {
                    y: -3,
                    duration: 0.2,
                    ease: 'power4.out',
                });
            });
            char.addEventListener('mouseleave', () => {
                gsap.to(chars[index - 1], {
                    y: 0,
                    duration: 0.2,
                    ease: 'power4.out',
                });
                gsap.to(char, {
                    y: 0,
                    duration: 0.2,
                    ease: 'power4.out',
                });
                gsap.to(chars[index + 1], {
                    y: 0,
                    duration: 0.2,
                    ease: 'power4.out',
                });
            });
        });
    }
}

export type SectionCard = {
    text: string;
    image: Image;
};
